(function () {
  var filterTags = document.querySelectorAll('.gallery-filter-bar .gallery-tag[data-filter]');
  var cards = document.querySelectorAll('.gallery-grid .gallery-card');

  filterTags.forEach(function (tag) {
    tag.addEventListener('click', function () {
      filterTags.forEach(function (t) { t.classList.remove('active'); });
      tag.classList.add('active');
      var filter = tag.dataset.filter;
      cards.forEach(function (card) {
        card.style.display = (filter === 'all' || card.dataset.category === filter) ? '' : 'none';
      });
    });
  });

  var lightbox = document.getElementById('ba-lightbox');
  if (lightbox) {
    var lbImg = lightbox.querySelector('.gallery-lightbox-img');
    var lbCaption = lightbox.querySelector('.gallery-lightbox-caption');
    var lbClose = lightbox.querySelector('.gallery-lightbox-close');

    document.querySelectorAll('.gallery-card img').forEach(function (img) {
      img.style.cursor = 'pointer';
      img.addEventListener('click', function () {
        lbImg.src = img.src;
        lbImg.alt = img.alt || '';
        lbCaption.textContent = img.closest('.gallery-card').querySelector('h4') ? img.closest('.gallery-card').querySelector('h4').textContent : '';
        lightbox.classList.add('open');
        document.body.style.overflow = 'hidden';
      });
    });

    var closeLightbox = function () {
      lightbox.classList.remove('open');
      document.body.style.overflow = '';
    };
    if (lbClose) lbClose.addEventListener('click', closeLightbox);
    lightbox.addEventListener('click', function (e) { if (e.target === lightbox) closeLightbox(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && lightbox.classList.contains('open')) closeLightbox();
    });
  }
})();
